/**
 * make url string combining url and params object
 * @param url url link
 * @param params params object from where make params
 * @returns result of combining url and params as valid url string
 */
export const makeUrlString = (url: string, params: URLSearchParams | null = null) => {
    return url + (params ? '?' + params.toString() : '');
};
